// src/pages/SellerSuccess/SuccessState.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db, auth } from '../../services/firebase';
import { sellerSuccessStyles } from './styles';
import FeaturesList from './FeaturesList';

// Success checkmark icon
const CheckCircleIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22,4 12,14.01 9,11.01"></polyline>
  </svg>
);

const SuccessState = () => {
  const navigate = useNavigate();
  const [buttonHover, setButtonHover] = useState(false);
  const [hasListings, setHasListings] = useState(false);

  useEffect(() => {
    const checkListings = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const listingsQuery = query(
        collection(db, 'listings'),
        where('sellerId', '==', user.uid)
      );
      const listingsSnap = await getDocs(listingsQuery);
      setHasListings(listingsSnap.size > 0);
    };

    checkListings();
  }, []);

  const handleCreateListing = () => {
    navigate('/add-listing');
  };

  return (
    <div style={sellerSuccessStyles.statusContent}>
      {/* Hero Section */}
      <div style={sellerSuccessStyles.heroSection}>
        <div style={sellerSuccessStyles.iconContainer}>
          <CheckCircleIcon />
        </div>
        <h1 style={sellerSuccessStyles.title}>Welcome to Redbird Markets!</h1>
        <p style={sellerSuccessStyles.description}>
          Congratulations! Your seller account is now active and ready to start earning money 
          on ISU's premier student marketplace.
        </p>
      </div>

      {/* Features Section */}
      <FeaturesList />

      {/* CTA Section */}
      <div style={sellerSuccessStyles.ctaSection}>
        <button
          onClick={handleCreateListing}
          onMouseEnter={() => setButtonHover(true)}
          onMouseLeave={() => setButtonHover(false)}
          style={{
            ...sellerSuccessStyles.primaryButton,
            ...(buttonHover ? {
              backgroundColor: '#a00f20',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 32px rgba(206, 17, 38, 0.4), 0 4px 16px rgba(206, 17, 38, 0.3)',
            } : {})
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
          </svg>
          {hasListings ? 'Create Another Listing' : 'Create First Listing'}
        </button>
        
        <div style={sellerSuccessStyles.redirectNotice}>
          <svg style={sellerSuccessStyles.redirectIcon} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M13.13 22.19l5.91-5.91c.78-.78.78-2.05 0-2.83L12.2 6.6l-1.41 1.41 6.25 6.25c.39.39.39 1.02 0 1.41L12.2 20.5l-6.25-6.25c-.39-.39-.39-1.02 0-1.41L12.2 6.6 10.79 5.19c-.78.78-.78 2.05 0 2.83l5.91 5.91-5.91 5.91c-.78.78-.78 2.05 0 2.83z"/>
          </svg>
          <span>{hasListings ? 'Keep the momentum going! Create more listings.' : 'Ready to start selling? Create your first listing now!'}</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessState;